import React, { Component } from 'react';
import './consumption.css';
import axios from 'axios';
import Swal from 'sweetalert2';

import moment from "moment";
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import Loading from '../../Components/Loading/Loading';


import { Line } from 'react-chartjs-2';

import { transactionID } from "../../services/helpers";


class Consumption extends Component {

  constructor(props) {
        super(props);

        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));

        this.state ={
            loading: 0,
            openDateTime: false,
            clientInfo: clientInfo,
            consumptionData: {
                internet: [],
                sms: [],
                telefone: [],
            },
            consumptionDataWithOutSum: {
                internet: [],
                sms: [],
                telefone: [],
            },
            labels: [],
            type: '',
            dataSets: [],
            borderColor: '',
            measurement: '',
            history: []
        };
        
        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo.accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

  };

  compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  changeChart(element, step) {

        console.log(element);

        [...document.querySelectorAll('.consumption .buttons .btn')].map((el) => {
            el.classList.remove('active');
        });

        element.classList.add('active');

        let borderColor, measurement;

        let dataSets = this.state.consumptionData[step].length > 0 ? 
                       this.state.consumptionData[step].map((item) => { return item.dataChart }).join(',').split(',')
                       : [];
        let labels = this.state.consumptionData[step].map((item) => { return moment(item.date, 'MM/DD/YYYY').format('D') }).join(',').split(',');

        
        switch(step){
            case 'internet':
                borderColor = '#ffd402';
                measurement = 'MB';
                break;
            case 'sms':
                borderColor = '#02406a';
                measurement = 'SMS';
                break;
            case 'telefone':
                borderColor = '#349ad2';
                measurement = 'Min';
                // console.log('this.state.consumptionData[step].length: ', this.state.consumptionData[step].length);
                dataSets = this.state.consumptionData[step].length > 0 ? 
                            this.state.consumptionData[step].map((item) => { return moment.duration(item.dataChart).asMinutes().toFixed(2) }).join(',').split(',')
                            : [];
                break;
        }

        

        
        this.setState({
            dataSets: dataSets, 
            labels: labels,
            type: step,
            measurement,
            borderColor: borderColor,
        });
        this.changeHistory(step);
  }

  changeHistory(step){

        let historyList = document.querySelector('.history-list').querySelectorAll('li');
        let currentHistory = document.querySelector('.history-list').querySelectorAll(`li.history-${step}`);

        historyList.forEach((list) => {
            list.classList.add('d-none');
        });

        currentHistory.forEach((list) => {
            list.classList.remove('d-none');
        });

  }

  getInfoMonth(year, month) {
    this.setState({loading: 1});

    axios.post('https://www.pagtel.com.br/Hub360Correios/v1/infoMonth',{

        transactionId: transactionID('ABA'),
        msisdn: this.state.clientInfo.number,
        year: year,
        month: month,
        msisdnAuth: '',

    }).then((response) => {

        

        switch(response.data.code){
            case 'P00':

                let chartData = response.data.details;

                let newMap = chartData.map((chart) => {

                    let type='', dataChart='', measurement='';

                    if(chart.line1.toLowerCase().indexOf('internet') >= 0){
                        // console.log('Internet: ', chart.line1.indexOf('Internet'));
                        type = 'internet';
                        measurement = 'MB';
                        dataChart = parseFloat(chart.line2.split(' ')[1]);
                    }

                    if(chart.line1.toLowerCase().indexOf('sms') >= 0){
                        // console.log('SMS: ', chart.line1.indexOf('SMS'));
                        type = 'sms'
                        measurement = 'SMS';
                        dataChart = parseInt(chart.line2.split(' ')[2]);
                    }

                    if(chart.line1.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf('ligacao') >= 0){
                        // console.log('Ligacao: ', chart.line1.indexOf('ligacao'));
                        type = 'telefone'
                        measurement = 'MIN';
                        dataChart = moment(chart.line2.split(' ')[3], 'HH:mm:ss').format('HH:mm:ss');
                        // console.log('dataChart: ', dataChart);
                    }

                    return {
                            
                            displayOrder: moment(chart.date, 'M/D/YYYY').format('X'),
                            type: type,
                            dataChart,
                            measurement: measurement,
                            ...chart
                    }
                    
                });

                let output = {
                    internet: [],
                    telefone: [],
                    sms: [],
                },
                withOutSum = {
                    internet: [],
                    telefone: [],
                    sms: []
                };
                newMap.forEach((res) => {

                    let checkExistiItem = '', dataChart = '';
                        checkExistiItem = output[res.type].findIndex((findRes) => findRes.displayOrder === res.displayOrder);

                    switch(res.type){
                        case 'internet':
                        case 'sms':
                            if(checkExistiItem >= 0) dataChart = output[res.type][checkExistiItem].dataChart + res.dataChart;
                            break;

                        case 'telefone':
                            //if(checkExistiItem >= 0) console.log('DURATION: ', moment(output[res.type][checkExistiItem].dataChart, 'HH:mm:ss').format('HH:mm:ss'), output[res.type][checkExistiItem].dataChart);
                            if(checkExistiItem >= 0) {
                                dataChart = moment.utc(moment.duration(output[res.type][checkExistiItem].dataChart).add(res.dataChart).asMilliseconds()).format('HH:mm:ss');
                                // console.log('dataChart: ', dataChart, res.dataChart);
                                // console.log('Exist ITEM: ', output[res.type][checkExistiItem].dataChart, res.dataChart);
                            }
                            break;
                    }

                    

                    if(output[res.type].length > 0 && checkExistiItem >= 0)  {
                        output[res.type][checkExistiItem].dataChart = dataChart;
                    }else{
                        output[res.type].push(res);
                    }

                    withOutSum[res.type].push(res);
                    
                });

                if(output.sms.length > 0)output.sms.sort(this.compareValues('displayOrder'));
                if(output.telefone.length > 0)output.telefone.sort(this.compareValues('displayOrder'));
                if(output.internet.length > 0)output.internet.sort(this.compareValues('displayOrder'));

                
                console.log('CONSUMO: ', withOutSum);

                this.setState({consumptionData:  output, consumptionDataWithOutSum: withOutSum });
                break;
        }


        let firstButton = document.querySelector('.consumption .buttons .btn');
       
        this.changeChart(firstButton, 'internet');
        // document.querySelectorAll('.consumption .buttons .btn').click();
        this.setState({loading: 0});
    });
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }

  componentDidMount() {

        document.onclick = (el) => {
            console.log(el.target.closest('.inputDateTime'));
            
            if(!el.target.closest('.inputDateTime') 
                && !el.target.closest('.rdtPicker')
                && !el.target.closest('.rdtMonths')
                && !el.target.closest('.rdtYears')
                ){
                this.setState({openDateTime: false});
            }
        }

        

        this.getInfoMonth(moment().format('YYYY'), moment().format('MM'));
        

  }
    
   
  changeDateTime(date) {
      console.log(date);
      
      this.getInfoMonth(moment(date).format('YYYY'), moment(date).format('MM'));

      this.setState({openDateTime: false});
  }
  

  render() {

    
    return (
        <div className="card consumption">
            <Loading loading={this.state.loading} />
            <div className="card-header">
                <h4>Consumo</h4>  
            </div>
            <div className="card-body">
                
                <div className="buttons d-flex flex-content-between ">
                    <button className="btn btn-outline-warning btn-sm" onClick={(element) => {this.changeChart(element.target, 'internet')}}>Internet</button>
                    <button className="btn btn-outline-default btn-sm" onClick={(element) => {this.changeChart(element.target, 'sms')}}>SMS</button>
                    <button className="btn btn-outline-info btn-sm" onClick={(element) => {this.changeChart(element.target, 'telefone')}}>Telefone</button>
                </div>
                <div className="center-item calendar">
                    <DateTime 
                        dateFormat="MM/YYYY" 
                        className={['inputDateTime']}
                        timeFormat={false} 
                        showToday={true}
                        closeOnSelect={true}
                        closeOnTab={true}
                        dateTime={moment()}
                        defaultValue={moment()}
                        onChange={(date) => {this.changeDateTime(date)}}
                        onFocus={() => {this.setState({openDateTime: true})}}
                        onBlur={() => {console.log('Click OUT: ');}}
                        open={this.state.openDateTime}
                    />
                </div>
                <div className="center-item chart">

                    {
                        this.state.dataSets.length > 0 ?

                    
                        <Line data={{
                                        labels: this.state.labels,
                                        datasets: [{ 
                                            data: this.state.dataSets,
                                            label: this.state.type,
                                            borderColor: this.state.borderColor,
                                            fill: true
                                        }]
                                    }} 
                        
                                options={{
                                    legend: {
                                        display: false
                                    },
                                    scales: {
                                        xAxes: [{
                                            /* type: 'linear', */
                                            ticks: {
                                                fontColor: "rgba(0,0,0,0.5)",
                                                fontStyle: "bold",
                                                beginAtZero: true,
                                                maxTicksLimit: 31,
                                                padding: 20,
                                                stepSize: 1
                                            },
                                            
                                            scaleLabel: {
                                                display: true,
                                                labelString: 'Dia(s)',
                                            }
                                        }],
                                        yAxes: [{
                                            ticks: {
                                                fontColor: "rgba(0,0,0,0.5)",
                                                fontStyle: "bold",
                                                beginAtZero: true,
                                                padding: 20,
                                                precision: 2,
                                                stepSize: 10
                                            },
                                            scaleLabel: {
                                                display: true,
                                                labelString: this.state.measurement,
                                            },
                                            
                                        }]
                                    }
                                }}
                        />

                    :
                    <div></div>

                    }
                </div>

                <div>
                    <p className="center-item title-history">Histórico</p>
                    <ul className="history-list">
                        {
                            this.state.consumptionDataWithOutSum.internet.length > 0 ?
                            this.state.consumptionDataWithOutSum.internet.map((response, key) => {
                                return (
                                    <li key={key} className={`status-warning history-${response.type} d-none`}>
                                        <div className="d-flex flex-content-between">
                                            <p className="title-history">

                                                {response.line1}
                                                
                                            </p>

                                            <p className="small-text color-gray-ligth p-0 m-0">{moment(response.date, 'M/D/YYYY').format('DD/MM/YYYY')}</p>
                                        </div>
                                        <p className="small-text color-gray-ligth p-0 m-0">{response.line2}</p>
                                        
                                    </li>
                                );
                            })
                            :
                            <li className={`status-warning history-internet d-none`}>
                                <div className="d-flex flex-content-between">
                                    <p className="title-history">Uso de Internet</p>
                                    <p className="small-text color-gray-ligth p-0 m-0"></p>
                                </div>
                                <p className="small-text color-gray-ligth p-0 m-0">Nenhum histórico para mostrar</p>
                                
                            </li>
                        }

                        {
                            this.state.consumptionDataWithOutSum.sms.length > 0 ?
                            this.state.consumptionDataWithOutSum.sms.map((response, key) => {
                                return (
                                    <li key={key} className={`status-default history-${response.type} d-none`}>
                                        <div className="d-flex flex-content-between">
                                            <p className="title-history">

                                                {
                                                    this.getCookie('sms') === "true" ? 
                                                    'SMS para ******' 
                                                    :
                                                    response.line1
                                                }
                                            
                                            </p>
                                            <p className="small-text color-gray-ligth p-0 m-0">{moment(response.date, 'M/D/YYYY').format('DD/MM/YYYY')}</p>
                                        </div>
                                        <p className="small-text color-gray-ligth p-0 m-0">{response.line2}</p>
                                        
                                    </li>
                                );
                            })
                            :
                            <li className={`status-default history-sms d-none`}>
                                <div className="d-flex flex-content-between">
                                    <p className="title-history">Uso de SMS</p>
                                    <p className="small-text color-gray-ligth p-0 m-0"></p>
                                </div>
                                <p className="small-text color-gray-ligth p-0 m-0">Nenhum histórico para mostrar</p>
                                
                            </li>
                        }

                        {
                            this.state.consumptionDataWithOutSum.telefone.length > 0 ?
                            this.state.consumptionDataWithOutSum.telefone.map((response, key) => {
                                return (
                                    <li key={key} className={`status-info history-${response.type} d-none`}>
                                        <div className="d-flex flex-content-between">
                                            <p className="title-history">
                                                {
                                                    this.getCookie('call') === "true" ?
                                                    'Ligação para ********' 
                                                    :
                                                    response.line1
                                                }
                                            </p>
                                            <p className="small-text color-gray-ligth p-0 m-0">{moment(response.date, 'M/D/YYYY').format('DD/MM/YYYY')}</p>
                                        </div>
                                        <p className="small-text color-gray-ligth p-0 m-0">{response.line2}</p>
                                        
                                    </li>
                                );
                            })
                            :
                            <li className={`status-info history-telefone d-none`}>
                                <div className="d-flex flex-content-between">
                                    <p className="title-history">Uso de Telefone</p>
                                    <p className="small-text color-gray-ligth p-0 m-0"></p>
                                </div>
                                <p className="small-text color-gray-ligth p-0 m-0">Nenhum histórico para mostrar</p>
                                
                            </li>
                        }
                    </ul>
                </div>

            </div>
        </div>
    )
  }

  
}

export default Consumption; // Don’t forget to use export default!